function isMobile(screen) {
    if( screen.width <= 760 ) {
        return true;
    }
    else {
        return false;
    }
}

export default isMobile